import styled from "styled-components";
import { Box } from "@thenounproject/lingo-core";

const SquareWrapper = styled(Box).attrs<{ interactive?: boolean }>(({ interactive }) => ({
  height: "100%",
  width: "100%",
  borderRadius: "2px",
  position: "relative",
  pointerEvents: interactive ? "auto" : "none",
}))<{ interactive?: boolean }>`
  ${({ interactive }) =>
    !interactive &&
    `
    * {
      pointer-events: none;
    }
  `}
`;

export default SquareWrapper;
